var map = {
	"./arrow-down.svg": 1530,
	"./back_arrow.svg": 1531,
	"./black-arrow.svg": 1532,
	"./boarding.png": 797,
	"./calendar.svg": 1533,
	"./close.svg": 1534,
	"./cloud.svg": 1535,
	"./employee.png": 798,
	"./file.svg": 799,
	"./google_calendar_logo.png": 1536,
	"./interview.png": 800,
	"./logo-velora-classic.svg": 791,
	"./logo.svg": 1537,
	"./logo_black.svg": 1538,
	"./mail.svg": 1539,
	"./marker.svg": 1540,
	"./meet_logo.png": 1541,
	"./mocks/avatar_mock.png": 1542,
	"./next-arrow.svg": 1543,
	"./notebook.svg": 1544,
	"./nothing.png": 801,
	"./office.png": 802,
	"./outlook_logo.png": 1545,
	"./pda.svg": 775,
	"./planning.svg": 1546,
	"./prev-arrow.svg": 1547,
	"./satisfaction_agree.png": 803,
	"./satisfaction_disagree.png": 804,
	"./satisfaction_little_disagree.png": 805,
	"./satisfaction_super_agree.png": 806,
	"./save-search-icon.svg": 1548,
	"./search.svg": 1549,
	"./skills.svg": 1550,
	"./stats.svg": 1551,
	"./surveys.png": 807,
	"./talent-clue-logo.png": 1006,
	"./talent.png": 808,
	"./teams_logo.png": 1552,
	"./tel.svg": 1553,
	"./tutor.png": 809,
	"./user-white.svg": 1554,
	"./user.svg": 1555,
	"./userStatus/confirmed.svg": 1556,
	"./userStatus/discarded.svg": 1557,
	"./userStatus/hired.svg": 1558,
	"./userStatus/no-suitable.svg": 1559,
	"./userStatus/not-attend.svg": 1560,
	"./userStatus/not-interested.svg": 1561,
	"./userStatus/reschedule.svg": 1562,
	"./userStatus/reserve.svg": 1563,
	"./userStatus/suitable.svg": 1564,
	"./userStatus/to-be-confirmed.svg": 1565,
	"./velora-isotipo-blanco.svg": 792,
	"./velora-login-background.svg": 810,
	"./velora.svg": 811,
	"./video.svg": 1566,
	"./welcome.png": 812
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1028;